export default [
    {
        path: '/design-system',
        component: () => import('../components/design_system/Index.vue'),
      children:[
        {
          path: '',
          name: 'DesignSystemOverview',
          component: () => import('../components/design_system/Overview.vue')
        },
        {
          path: 'accordion',
          name: 'DesignSystemAccodion',
          component: () => import('../components/design_system/Accordion.vue')
        },
        {
          path: 'blade-header',
          name: 'DesignSystemBladeHeader',
          component: () => import('../components/design_system/BladeHeader.vue')
        },
        {
          path: 'bottom-action-bar',
          name: 'DesignSystemBottomActionBar',
          component: () => import('../components/design_system/BottomActionBar.vue')
        },
        {
          path: 'breadcrumb',
          name: 'DesignSystemBreadcrumb',
          component: () => import('../components/design_system/Breadcrumb.vue')
        },
        {
          path: 'button',
          name: 'DesignSystemButton',
          component: () => import('../components/design_system/Button.vue')
        },
        {
          path: 'checkbox',
          name: 'DesignSystemCheckbox',
          component: () => import('../components/design_system/Checkbox.vue')
        },
        {
          path: 'chip',
          name: 'DesignSystemChip',
          component: () => import('../components/design_system/Chip.vue')
        },
        {
          path: 'color-system',
          name: 'DesignSystemColorSystem',
          component: () => import('../components/design_system/ColorSystem.vue')
        },
        {
          path: 'communication',
          name: 'DesignSystemCommunication',
          component: () => import('../components/design_system/Communication.vue')
        },
        {
          path: 'combobox',
          name: 'DesignSystemCombobox',
          component: () => import('../components/design_system/Combobox.vue')
        },
        {
          path: 'component-registration',
          name: 'DesignSystemComponentRegistration',
          component: () => import('../components/design_system/ComponentRegistration.vue')
        },
        {
          path: 'component-usage',
          name: 'DesignSystemComponentUsage',
          component: () => import('../components/design_system/ComponentUsage.vue')
        },
        {
          path: 'elevation',
          name: 'DesignSystemElevation',
          component: () => import('../components/design_system/Elevation.vue')
        },
        {
          path: 'empty-state',
          name: 'DesignSystemEmptyState',
          component: () => import('../components/design_system/EmptyState.vue')
        },
        {
          path: 'file-input',
          name: 'DesignSystemFileInput',
          component: () => import('../components/design_system/FileInput.vue')
        },
        {
          path: 'form',
          name: 'DesignSystemForm',
          component: () => import('../components/design_system/Form.vue')
        },
        {
          path: 'global-css',
          name: 'DesignSystemCss',
          component: () => import('../components/design_system/GlobalCss.vue')
        },
        {
          path: 'global-notification',
          name: 'DesignSystemGlobalNotification',
          component: () => import('../components/design_system/GlobalNotification.vue')
        },
        {
          path: 'header-info',
          name: 'DesignSystemHeaderInfo',
          component: () => import('../components/design_system/HeaderInfo.vue')
        },
        {
          path: 'header',
          name: 'DesignSystemHeader',
          component: () => import('../components/design_system/Header.vue')
        },
        {
          path: 'icon',
          name: 'DesignSystemIcon',
          component: () => import('../components/design_system/Icon.vue')
        },
        {
          path: 'info-card',
          name: 'DesignSystemInfoCard',
          component: () => import('../components/design_system/InfoCard.vue')
        },
        {
          path: 'input',
          name: 'DesignSystemInput',
          component: () => import('../components/design_system/Input.vue')
        },
        {
          path: 'link',
          name: 'DesignSystemLink',
          component: () => import('../components/design_system/Link.vue')
        },
        {
          path: 'media-viewer',
          name: 'DesignSystemMediaViewer',
          component: () => import('../components/design_system/MediaViewer.vue')
        },
        {
          path: 'menu',
          name: 'DesignSystemMenu',
          component: () => import('../components/design_system/Menu.vue')
        },
        {
          path: 'mini-profile',
          name: 'DesignSystemMiniProfile',
          component: () => import('../components/design_system/MiniProfile.vue')
        },
        {
          path: 'modal',
          name: 'DesignSystemModal',
          component: () => import('../components/design_system/Modal.vue')
        },
        {
          path: 'notification',
          name: 'DesignSystemNotification',
          component: () => import('../components/design_system/Notification.vue')
        },
        {
          path: 'page-menu',
          name: 'DesignSystemPageMenu',
          component: () => import('../components/design_system/PageMenu.vue')
        },
        {
          path: 'property-selector',
          name: 'DesignSystemPropertySelector',
          component: () => import('../components/design_system/PropertySelector.vue')
        },
        {
          path: 'radio',
          name: 'DesignSystemRadio',
          component: () => import('../components/design_system/Radio.vue')
        },
        {
          path: 'spacing',
          name: 'DesignSystemSpacing',
          component: () => import('../components/design_system/Spacing.vue')
        },
        {
          path: 'space-icon',
          name: 'DesignSystemSpaceIcon',
          component: () => import('../components/design_system/SpaceIcon.vue')
        },
        {
          path: 'status',
          name: 'DesignSystemStatus',
          component: () => import('../components/design_system/Status.vue')
        },
        {
          path: 'status-general',
          name: 'DesignSystemStatusGeneral',
          component: () => import('../components/design_system/StatusGeneral.vue')
        },
        {
          path: 'stepper',
          name: 'DesignSystemStepper',
          component: () => import('../components/design_system/Stepper.vue')
        },
        {
          path: 'switch',
          name: 'DesignSystemSwitch',
          component: () => import('../components/design_system/Switch.vue')
        },
        {
          path: 'table',
          name: 'DesignSystemTable',
          component: () => import('../components/design_system/Table.vue')
        },
        {
          path: 'tabs',
          name: 'DesignSystemTabs',
          component: () => import('../components/design_system/Tabs.vue')
        },
        {
          path: 'tabs-responsive',
          name: 'DesignSystemTabsResponsive',
          component: () => import('../components/design_system/TabsResponsive.vue')
        },
        {
          path: 'task',
          name: 'DesignSystemTask',
          component: () => import('../components/design_system/Task.vue')
        },
        {
          path: 'timeline',
          name: 'DesignSystemTimeline',
          component: () => import('../components/design_system/Timeline.vue'),
        },
        {
          path: 'toast',
          name: 'DesignSystemToast',
          component: () => import('../components/design_system/Toast.vue')
        },
        {
          path: 'tooltip',
          name: 'DesignSystemTooltip',
          component: () => import('../components/design_system/Tooltip.vue')
        },
        {
          path: 'typography',
          name: 'DesignSystemTypography',
          component: () => import('../components/design_system/Typography.vue')
        },
        {
          path: 'unit-icon',
          name: 'DesignSystemUnitIcon',
          component: () => import('../components/design_system/UnitIcon.vue')
        },
      ]
    }
  ]